import { render, staticRenderFns } from "./Yn.vue?vue&type=template&id=89b9563c&scoped=true"
import script from "./Yn.vue?vue&type=script&lang=js"
export * from "./Yn.vue?vue&type=script&lang=js"
import style0 from "./Yn.vue?vue&type=style&index=0&id=89b9563c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b9563c",
  null
  
)

export default component.exports